import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { QueryOption } from '../@types';
import { InteractionRuleObject } from '../@types/interaction.type';
import { InteractionsRulesQueryResponse } from '../@types/interactionsRules.type';
import { getAllInteractionsRulesConfigs, getInteractionRuleById } from '../api/interactions';
import { InteractionsRulesConfigsKey } from '../configs/interactions-rules';

export const useGetAllInteractionsRulesConfigs = ( queryOption: QueryOption ): UseQueryResult<InteractionsRulesQueryResponse> => {
  return useQuery({
    queryKey: [InteractionsRulesConfigsKey, queryOption.filterModel],
    queryFn: () => getAllInteractionsRulesConfigs(queryOption),
    gcTime: 0
  });
};

export const useGetInteractionRuleById = (id: number): UseQueryResult<InteractionRuleObject> => {
  return useQuery({
    queryKey: [InteractionsRulesConfigsKey, id],
    queryFn: () => getInteractionRuleById(id),
    enabled: false
  });
};